// localStorage keys for cross-component state

/** Key for storing newly created portfolio slug (for sidebar highlight) */
export const NEW_PORTFOLIO_KEY = "new-portfolio-slug";

/** Key for storing sidebar portfolios section expanded state */
export const PORTFOLIOS_EXPANDED_KEY = "sidebar-portfolios-expanded";

/** Prefix for storing individual portfolio expanded states */
export const PORTFOLIO_EXPANDED_PREFIX = "sidebar-portfolio-expanded-";
